<template>
  <div class="press-results">
    <div class="fbcgTitleBgDiv">
      <img src="../../../assets/fbcgTitleBg.png" class="fbcgTitleBgImg" />
    </div>
    <div class="menuDiv">
      <div
        class="cgMenu"
        v-for="(item, index) in menuList"
        :key="index"
        @click="handleMenuClick(index)"
      >
        <div class="cgMenu">
          <img
            :src="activeIndex === index ? item.activeIcon : item.icon"
            class="cgmImg"
            :style="{ width: index === menuList.length - 1 ? '18px' : '' }"
          />
        </div>
        <div class="cgmText" :class="{ textActive: activeIndex === index }">
          {{ item.name }}
        </div>
      </div>
      
    </div>

    <div class="searchDiv">
      <el-select
        filterable
        v-show="activeIndex === 0"
        style="width: 100%"
        v-model="form.scope"
        clearable
        placeholder="请选择所属领域"
        size="small"
        @change="handleSelectChange"
      >
        <el-option
          :label="item.title"
          :value="item.id"
          v-for="(item, index) in dictList"
          :key="index"
        ></el-option>
      </el-select>

      <el-select
        filterable
        v-show="activeIndex === 1"
        v-model="form.orgRec_id"
        clearable
        style="width: 100%"
        placeholder="请选择推荐单位"
        size="small"
        @change="handleSelectChange"
      >
        <el-option
          :label="item.user_name"
          :value="item.id"
          v-for="(item, index) in unitList"
          :key="index"
        ></el-option>
      </el-select>

      <el-select
        v-show="activeIndex === 2"
        filterable
        v-model="form.personRec_id"
        clearable
        style="width: 100%"
        placeholder="请选择推荐个人"
        size="small"
        @change="handleSelectChange"
      >
        <el-option
          :label="item.user_name"
          :value="item.id"
          v-for="(item, index) in individualList"
          :key="index"
        ></el-option>
      </el-select>

      <el-select
        v-show="activeIndex === 3"
        filterable
        style="width: 100%"
        v-model="form.org_province_name"
        clearable
        placeholder="请选择项目地区"
        size="small"
        @change="handleSelectChange"
      >
        <el-option
          :label="item.name"
          :value="item.name"
          v-for="(item, index) in provinceList"
          :key="index"
        ></el-option>
      </el-select>
    </div>

    <div class="listDiv" v-if="homeProjectData.length>0">
      <div
        class="itemContent"
        :class="getBgClass(index)"
        v-for="(item, index) in homeProjectData"
        :key="index"
        @click="goDetail(item)"
      >
        <div class="itemTitle">{{ item.optimize_name }}</div>
        <div class="itemSubTitle">{{item.optimize_profile }}</div>
      </div>
    </div>

    <div style="display: flex;justify-content: center;margin-top: 40px;" v-else>
    <img src="../../../assets/empit.png" class="empitImg" />
    </div>

        <div class="pageBox" v-if="homeProjectData.length>0">
        <el-pagination @size-change="sizePagination" :page-sizes="[9, 30, 50, 100]" @current-change="currentPagination" :page-size="form.pageSize"
          background layout="prev, pager, next,sizes" :total="projectTotal">
        </el-pagination>
      </div>
  </div>
</template>

<script>
export default {
  name: "PressResults",
  props: {},
  data() {
    return {
      homeProjectData: [],
      projectTotal: 100,
      dictList: [],
      unitList: [],
      provinceList: [],
      individualList: [],
      activeIndex: 0,
      form: {
        scope: "",
        orgRec_id: "",
        personRec_id: "",
        org_province_name: "",
        currPage: 1,
        pageSize: 9,
      },
      menuList: [
        {
          name: "按成果领域查看",
          icon: require("@/assets/cgm1.png"),
          activeIcon: require("@/assets/cgm11.png"),
        },
        {
          name: "按推荐单位查看",
          icon: require("@/assets/cgm2.png"),
          activeIcon: require("@/assets/cgm22.png"),
        },
        {
          name: "按推荐个人查看",
          icon: require("@/assets/cgm3.png"),
          activeIcon: require("@/assets/cgm33.png"),
        },
        {
          name: "按成果地区查看",
          icon: require("@/assets/cgm4.png"),
          activeIcon: require("@/assets/cgm44.png"),
        },
      ],
    };
  },
  mounted() {
    this.getSelectData();
    this.getTableList();
  },
  methods: {
    handleSelectChange() {
      this.getTableList();
    },
    sizePagination(e) {
      this.form.pageSize = e;
      this.getTableList();
    },
    currentPagination(e) {
      this.form.currPage = e;
      this.getTableList();
    },
    handleMenuClick(index) {
      this.activeIndex = index;
      this.getSelectData()
      this.getTableList();
    },
    async getTableList() {
      this.loading = true;
      this.form.selectType = this.activeIndex+1
      try {
        this.$API.getHomeProject(this.form).then((res) => {
          this.homeProjectData = res.data.list;
          this.projectTotal = res.data.pageInfo.allRows;
        });
      } catch (error) {
        console.error("获取列表数据失败:", error);
      } finally {
        this.loading = false;
      }
    },
    goDetail(item){
      this.$router.push({
        path: '/AchievementDetail',
        query: {
          data: JSON.stringify(item),
          id:this.$route.query.id
        }
      })
    },
    async getSelectData() {
            this.form={
        game_id :this.$route.query.id,
        scope:'',
        orgRec_id:'',
        personRec_id:'',
        org_province_name:'',
        currPage:1,
        pageSize:9
      }
      switch (this.activeIndex) {
        case 0:
          this.$API.getDict({ pid: 66 }).then((res) => {
            this.dictList = res.data;
          });
          break;
        case 1:
          this.$API.getLoginRecommendList({ identify: 1 }).then((res) => {
            this.unitList = res.data;
          });
          break;
        case 2:
          this.$API.getLoginRecommendList({ identify: 2 }).then((res) => {
            this.individualList = res.data;
          });
          break;
        case 3:
          this.$API.getProvinceList({ pid: 0 }).then((res) => {
            this.provinceList = res.data;
          });
          break;
      }
    },
    getBgClass(index) {
      const pos = index % 3;
      if (pos === 0) return 'bg1';
      if (pos === 1) return 'bg2';
      return 'bg3';
    },
  },
};
</script>

<style scoped lang="scss">
.empitImg{
  width: 200px;
  height: 200px;
}
.pageBox {
  width: 100%;
  display: flex;
  justify-content: end;
  cursor: pointer;
  margin-bottom: 30px;
}

.itemSubTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #5E6A7A;
line-height: 30px;
margin-top: 5px;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;

}
.itemTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 16px;
line-height: 30px;
color: #444444;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;

}
.itemContent{
  width: 32%;
  height: 160px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  padding: 30px 21px;
  margin-right: 16px;
  margin-bottom: 30px;
  cursor: pointer;
}
.bg1 { background-image: url('../../../assets/cgListBg1.png'); }
.bg2 { background-image: url('../../../assets/cgListBg2.png'); }
.bg3 { background-image: url('../../../assets/cgListBg3.png'); }
.listDiv{
display: flex;
flex-wrap: wrap;
}


::v-deep .searchDiv .el-input__suffix {
  display: flex;
  align-items: center;
}
::v-deep .searchDiv .el-input__icon {
  width: 20px;
  height: 20px;
  background: #b6cffe;
  color: #fff !important;
  border-radius: 50%;
  line-height: 20px;
}
::v-deep .searchDiv .el-input__inner {
  height: 51px;
  background: #eaf2ff;
  border-radius: 26px 26px 26px 26px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #5e6a7a;
  border: none;
}
.searchDiv {
  padding: 0 145px;
  margin-top: 20px;
  margin-bottom: 30px;
}
.menuDiv {
  display: flex;
  justify-content: space-around;
  padding: 0 100px;
}
.cgmText {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #444444;
  margin-left: 10px;
}
.textActive {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #0366f1;
}
.cgmImg {
  width: 20px;
  height: 20px;
}
.cgMenu {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.fbcgTitleBgDiv {
  display: flex;
  justify-content: center;
}
.fbcgTitleBgImg {
  width: 400px;
  height: 72px;
  margin: 50px 0 30px 0;
}
.press-results {
}
</style>
